<!--
 * @Author: chengchangjun
 * @Description: 多监控电视墙及轮播
-->
<template>
  <player
    :code="currentCodeList"
    v-if="showPlayer"
    :isCodeFirstInit="isCodeFirstInit"
    :evenOrOdd="evenOrOdd"
    :typeNum="typeNum"
    ref="player"
  ></player>
</template>

<script>
import { divide, ceil, slice, get, cloneDeep } from 'lodash'
import player from './video'

export default {
  props: {
    reverse: {
      type: Boolean,
      default: false,
    },
    cameraCodes: {
      type: Array,
      default: () => [],
    },
    // 9宫格 | 4宫格
    typeNum: {
      type: Number,
      default: 4,
    },
  },
  watch: {
    cameraCodes(val) {
      this.isCodeFirstInit = true
      if (this.count !== 0) {
        this.insertPlay(val)
      }
    },
  },
  data() {
    return {
      allCodes: [],
      count: 0,
      currentCodeList: [], // 监控code列表
      index: 1, // 计时器 计算可以轮播多少次
      currenIndex: 1,
      showPlayer: false,
      videoInterval: null,
      isCodeFirstInit: true, // code是否首次传值过去
      evenOrOdd: 1, // 每20秒切换，evenOrOdd的值也切换，值为1、0；1为前4个窗口，0为后四个窗口
    }
  },
  computed: {
    cameraTouringStep() {
      return (
        get(Wiz, 'dynamicModules.instances["visualization-cockpit"].config.cameraTouringStep') || 15
      )
    },
  },
  methods: {
    // 插入播放
    insertPlay(codes) {
      clearInterval(this.videoInterval)
      if (this.typeNum === 1) {
        this.allCodes = cloneDeep(this.cameraCodes)
        this.currentCodeList = cloneDeep(this.cameraCodes)
        return
      }
      this.currenIndex = 1
      this.allCodes = codes.concat(codes.slice(0, this.typeNum - (codes.length % this.typeNum)))
      this.index = ceil(divide(this.allCodes.length, this.typeNum))
      this.currentCodeList = slice(this.allCodes, 0, this.currenIndex * this.typeNum)
      this.currenIndex += 1
      this.setInterCode()
    },
    // 获取摄像头列表
    async getVideoList() {
      if (this.typeNum === 1) {
        this.allCodes = cloneDeep(this.cameraCodes)
        this.currentCodeList = cloneDeep(this.cameraCodes)
        return
      }
      this.allCodes = this.cameraCodes.concat(
        this.cameraCodes.slice(0, this.typeNum - (this.cameraCodes.length % this.typeNum))
      )
      if (this.reverse) {
        this.allCodes.reverse()
      }
      this.index = ceil(divide(this.allCodes.length, this.typeNum))
      this.showPlayer = true
      this.getCurrentCode() // 初始进来获取四条数据
      this.setInterCode()
    },
    getCurrentCode() {
      if (this.count === 0) {
        this.currentCodeList = slice(
          this.allCodes,
          (this.currenIndex - 1) * this.typeNum,
          this.currenIndex * this.typeNum * 2
        )
        this.count += 1
      } else {
        this.currentCodeList = slice(
          this.allCodes,
          (this.currenIndex - 1) * this.typeNum,
          this.currenIndex * this.typeNum
        )
      }
      this.currenIndex += 1
      if (this.currenIndex > this.index) {
        this.currenIndex = 1
      }
    },
    setInterCode() {
      this.videoInterval = setInterval(() => {
        this.isCodeFirstInit = false
        this.evenOrOdd = this.evenOrOdd === 1 ? 0 : 1
        this.getCurrentCode()
      }, this.cameraTouringStep * 1000)
    },
  },
  components: { player },
  created() {
    this.getVideoList()
  },
  beforeDestroy() {
    if (this.videoInterval) {
      clearInterval(this.videoInterval)
    }
  },
}
</script>

<style></style>
